import React from 'react';
import PropTypes from 'prop-types';
import { Button as ButtonComponent } from '@material-ui/core';

const Button = ({ children, label, ...props }) => {
  return (
    <ButtonComponent fullWidth variant="contained" {...props}>
      {label || children}
    </ButtonComponent>
  );
};

Button.propTypes = {
  /** The content of the button. label has priority over children. */
  label: PropTypes.node,
  /** The content of the button. */
  children: PropTypes.node,
  /** If true, the button will be disabled. */
  disabled: PropTypes.bool,
  /** The variant to use. */
  variant: PropTypes.oneOf(['contained', 'outlined', 'text']),
};

Button.defaultProps = {
  label: null,
  children: '',
};

export default Button;
